export default __webpack_public_path__ + "static/media/pattern-flowered.f066c164.png";